module.exports = __webpack_public_path__ + "img/cloggedcatchbasin_attached.819537c8.svg";